import RequestedStatus from "./requestedstatus";
import OpenStatus from "./openstatus";
import EnrouteStatus from "./enroutestatus";
import ArrivedStatus from "./arrivedstatus";
import PartsStatus from "./partsstatus";
import CompleteStatus from "./completestatus";
import ReviewedStatus from "./reviewedstatus";
import BilledStatus from "./billedstatus";
import CancelledStatus from "./cancelledstatus";
import QuoteStageStatus from "./quotestagestatus";

// quoteStage: a customer quote request's stage (wo.quoteStage), shown instead
// of "Requested" while it's being quoted.
const WOStatusComponent = ({ value, quoteStage = null }) => {
  if (value === 0) {
    return quoteStage ? <QuoteStageStatus stage={quoteStage} /> : <RequestedStatus />;
  } else if (value === 1) {
    return <OpenStatus />;
  } else if (value === 2) {
    return <EnrouteStatus />;
  } else if (value === 3) {
    return <ArrivedStatus />;
  } else if (value === 4) {
    return <PartsStatus />;
  } else if (value === 5) {
    return <CompleteStatus />;
  } else if (value === 6) {
    return <ReviewedStatus />;
  } else if (value === 100) {
    return <BilledStatus />;
  } else if (value === 101) {
    return <CancelledStatus />;
  } else {
    return "";
  }
};

export default WOStatusComponent;
